var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimaArticle',[_c('p',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('Jury.title')))]),_vm._l((_vm.juryArray),function(member){return _c('JuryMember',{key:member,attrs:{"name":member}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }